module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-view"
  }, [(_vm.activeView === 'data') ? _c('div', {
    attrs: {
      "id": "visualization"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : (_vm.activeView === 'json') ? _c('div', {
    staticClass: "result-view",
    attrs: {
      "id": "json"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.result))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rowChartDataTable"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Number of Sales per Property Type")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "rowChart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Latest Property Sale")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dataGrid"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Average Price Paid per Year")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "barChart"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d486ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultView.vue
// module id = 154
// module chunks = 1